import React, { useRef } from 'react';
import { useIntl } from 'react-intl';

import useTruncatedText from './useTruncatedText';
import './TruncatedText.css';

function TruncatedText({
  text,
  maxLines = 2,
  normalizeWhitespace = true,
  enabled = true,
  className = '',
  style = {},
  measurerStyle = {},
  toggleClassName = 'truncated-text-toggle text-primary',
  moreLabel,
  lessLabel,
  whiteSpace = 'normal',
}) {
  const intl = useIntl();
  const contentIdRef = useRef(
    `truncated-text-${Math.random().toString(36).substr(2, 9)}`
  );
  const resolvedMoreLabel =
    moreLabel ?? intl.formatMessage({ id: 'label.mais' });
  const resolvedLessLabel =
    lessLabel ?? intl.formatMessage({ id: 'label.menos' });

  const {
    hostRef,
    measureRef,
    isExpanded,
    setIsExpanded,
    hasOverflow,
    preview,
    fullText,
  } = useTruncatedText(text, {
    maxLines,
    moreLabel: resolvedMoreLabel,
    normalizeWhitespace,
    enabled,
  });

  if (!enabled || !fullText) {
    return null;
  }

  const hostStyle = {
    wordBreak: 'break-word',
    whiteSpace,
    ...style,
  };

  const measureDefaults = {
    fontFamily: style.fontFamily,
    fontSize: style.fontSize,
    fontWeight: style.fontWeight,
    lineHeight: style.lineHeight,
    letterSpacing: style.letterSpacing,
    whiteSpace,
    ...measurerStyle,
  };

  return (
    <>
      <div
        ref={hostRef}
        id={contentIdRef.current}
        className={className}
        style={hostStyle}
      >
        {isExpanded || !hasOverflow ? fullText : preview}
        {hasOverflow && !isExpanded && (
          <>
            ...{' '}
            <button
              type="button"
              className={toggleClassName}
              aria-expanded={false}
              aria-controls={contentIdRef.current}
              onClick={(e) => {
                e.stopPropagation();
                setIsExpanded(true);
              }}
            >
              {resolvedMoreLabel}
            </button>
          </>
        )}
        {hasOverflow && isExpanded && (
          <>
            {' '}
            <button
              type="button"
              className={toggleClassName}
              aria-expanded={true}
              aria-controls={contentIdRef.current}
              onClick={(e) => {
                e.stopPropagation();
                setIsExpanded(false);
              }}
            >
              {resolvedLessLabel}
            </button>
          </>
        )}
      </div>
      <div
        ref={measureRef}
        aria-hidden
        className="truncated-text-measurer"
        style={measureDefaults}
      />
    </>
  );
}

export default TruncatedText;
